"use client"

import type { KeyboardEvent } from "react"
import { theme } from "antd"
import Paragraph from "@/components/common/Typography/Paragraph"
import SupportIcon from "@/components/icons/SupportIcon"
import { getLocalizedText } from "../utils/getLocalizedText"
import type { FaqDto } from "../types"

type FaqInfoCardProps = {
  faq: FaqDto
  locale: string
  image?: string
  description?: string
  onOpen: (faq: FaqDto) => void
  className?: string
}

export default function FaqInfoCard({ faq, locale, image, description, onOpen, className }: FaqInfoCardProps) {
  const { token } = theme.useToken()
  const question = getLocalizedText(faq.question, locale)

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      onOpen(faq)
    }
  }

  return (
    <div
      className={`faq-info-card${className ? ` ${className}` : ""}`}
      style={{ background: token.colorBgContainer }}
      role="button"
      tabIndex={0}
      onClick={() => onOpen(faq)}
      onKeyDown={handleKeyDown}
    >
      <div className="faq-info-card__header">
        <div className="faq-info-card__logo" style={{ background: token.colorFillTertiary }}>
          {image ? (
            <img src={image} alt={question} />
          ) : (
            <SupportIcon style={{ fontSize: "1.8rem", color: token.colorTextDisabled }} />
          )}
        </div>
        <Paragraph ellipsis={{ rows: 2, tooltip: question }} className="faq-info-card__title">
          {question}
        </Paragraph>
      </div>
      <Paragraph type="secondary" ellipsis={{ rows: 2, tooltip: description }} className="faq-info-card__description">
        {description}
      </Paragraph>
    </div>
  )
}
